import { format, isToday as isTodayFns, getDate } from "date-fns"

interface DayHeaderProps {
  date: Date
}

export default function DayHeader({ date }: DayHeaderProps) {
  const isToday = isTodayFns(date)
  const dayNum = getDate(date)
  const dayName = format(date, "eeee")

  return (
    <div className="flex items-center justify-center gap-1 text-sm font-semibold capitalize">
      <span className={`${isToday ? "text-primary-500" : ""}`}>{dayName}</span>
      <span
        className={`flex size-[30px] items-center justify-center rounded-full ${isToday ? "bg-primary-500 text-white" : ""}`}
      >
        {dayNum}
      </span>
    </div>
  )
}
